module.exports = __webpack_public_path__ + "img/c4.81226b12.jpg";